export enum SectionStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "INPROGRESS",
  COMPLETED = "COMPLETED",
}
export enum SectionVideoStatus {
  ALL = "ALL",
  NEW = "NOT_STARTED",
  OPEN = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  HIDDEN = "HIDDEN",
}

export interface CourseFilters {
  completionStatus: SectionVideoStatus;
}

export interface SectionVideoStatusLabel {
  value: SectionVideoStatus;
  label: string;
}

export type SectionFilter = {
  lessonStatus: SectionVideoStatus;
  userStatus: SectionVideoStatus;
};
export const DEFAULT_SECTION_FILTER: SectionFilter = {
  lessonStatus: SectionVideoStatus.ALL,
  userStatus: SectionVideoStatus.ALL,
};

export const sectionVideoUserStatusLabels: SectionVideoStatusLabel[] = [
  {
    value: SectionVideoStatus.ALL,
    label: "ALL",
  },
  {
    value: SectionVideoStatus.NEW,
    label: "NEW",
  },
  {
    value: SectionVideoStatus.OPEN,
    label: "OPEN",
  },
  {
    value: SectionVideoStatus.COMPLETED,
    label: "FINISHED",
  },
];

export const sectionVideoAdminStatusLabels: SectionVideoStatusLabel[] = [
  {
    value: SectionVideoStatus.ALL,
    label: "ALL",
  },
  {
    value: SectionVideoStatus.ACTIVE,
    label: "UNLOCKED",
  },
  {
    value: SectionVideoStatus.INACTIVE,
    label: "LOCKED",
  },
  {
    value: SectionVideoStatus.HIDDEN,
    label: "HIDDEN",
  },
];
